import { twMerge } from "tailwind-merge";

interface CheckboxProps {
  isChecked: boolean;
  label?: string;
  onCheck?: (isChecked: boolean) => void;
  disabled?: boolean;
}

export default function OmniCheckbox({
  isChecked,
  label = "",
  onCheck,
  disabled = false,
}: CheckboxProps) {
  return (
    <div className="flex items-center gap-1">
      <div
        className={twMerge(
          "aspect-square w-4 rounded-sm border border-zinc-300 transition-colors duration-300",
          disabled
            ? "cursor-not-allowed opacity-50"
            : "cursor-pointer",
          isChecked && !disabled && "bg-zinc-100",
          isChecked && disabled && "bg-gray-200"
        )}
        onClick={() => {
          if (!!onCheck && !disabled) {
            onCheck(!isChecked);
          }
        }}
      >
        {isChecked && (
          <i className={twMerge(
            "bi bi-check-lg flex h-full w-full items-center justify-center",
            disabled ? "text-gray-400" : "text-zinc-500"
          )} />
        )}
      </div>
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}